<template>
  <div>
    <el-upload
      class="upload-demo"
      action="#"
      accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PBG"
      :http-request="requestUpload"
      :show-file-list="false"
      :before-upload="beforeUpload"
      v-if="images.length < limit"
    >
      <div class="upload-btn">
        <img src="@/imgs/release/upload.png" class="upload-icon" />
        <span>{{ $t("点击上传") }}</span>
      </div>
    </el-upload>
    <div class="imgs" v-if="images.length != 0">
      <div class="img-li" v-for="(item, index) in images" :key="index">
        <img src="@/imgs/release/close.png" class="close" @click="remove(index)" />
        <img :src="item.path || item" class="upload-img" />
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/request1";
export default {
  props: {
    limit: {
      type: Number,
      default: 99,
    },
    imgs: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    images() {
      return this.imgs;
    },
  },
  methods: {
    // 上传前校验
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      var isIMG = true;
      if (!isJPG) {
        if (!isPNG) {
          this.$message.error(this.$t("上传图片只能是 JPG, PNG 格式!"));
          isIMG = false;
        }
      }
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error(this.$t("上传头像图片大小不能超过 2MB!"));
      }
      return isIMG && isLt2M;
    },
    requestUpload(file) {
      let uploadFile = file.file;
      let form = new FormData();
      form.append("file", uploadFile);
      form.append("module", "");
      form.append("dir", "");
      api
        .post5d5fa8984f0c2(form)
        .then((res) => {
          if (res.code == 1) {
            this.images.push(res.data[0]);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.$emit("upload", this.images);
    },
    remove(i) {
      this.images.splice(i, 1);
      this.$emit("remove", this.images);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "themePath/release";
.img-li {
  width: 30% !important;
  float: left;
  margin-right: 10px;
  margin-top: 10px;
}
.img-li:nth-child(3n) {
  margin-right: 0;
}
.imgs {
  width: 468px;
  clear: both;
  content: "";
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/release/components/uploadImage.vue